import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import IntroductionFeatures from "./sections/IntroductionFeatures";
import VentajasAdvantages from "./sections/VentajasAdvantages";
import CmoFuncionaHowItWorks from "./sections/CmoFuncionaHowItWorks";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <HeroSection />
      <IntroductionFeatures />
      <VentajasAdvantages />
      <CmoFuncionaHowItWorks />
      <Footer />
    </div>;
}